import { Slide } from "@jelly/lesson";
import theory from "../../theory";

import spectrum from "./components/spectrum";
import tonalityHm from "./components/tonality-hm";
import tonalityDin from "./components/tonality-din";
import prominenceRatio from "./components/prominence-ratio";
import toneToNoiseRatio from "./components/tone-to-noise-ratio";

const principle: Slide = {
  description:
    "Tonal components can be detected and evaluated using different analyses. Below, you can compare the output provided by different algorithms related to tonality, on sounds with varying complexity and different types of tonal components.",
  theory: theory,
  layout: {
    type: "buttonsToggle",
    options: {
      controlsPosition: "top",
      labels: [
        [
          { name: "Spectrum" },
          { name: "Tonality (HM) (ECMA-74)" },
          { name: "Tonality (DIN45681)" },
          { name: "Prominence Ratio (ECMA-74)" },
          { name: "Tone to Noise Ratio (ECMA-74)" },
        ],
      ],
      components: [spectrum, tonalityHm, tonalityDin, prominenceRatio, toneToNoiseRatio],
    },
  },
};

export default principle;
